import { useEffect } from "react";
import { useState } from "react";
import axiosInstance from "../../../../axiosInstance";

export const useCatalogCurrent = (
  storeId,
  supplierId,
  search = "",
  pageNo,
  pageSize
) => {
  const [catalog, setCatalog] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [toggle, setToggle] = useState(false);

  useEffect(() => {
    const controller = new AbortController();

    const loadCatalog = async () => {
      if (!storeId || !supplierId) return;
      try {
        setIsLoading(true);
        const result = await axiosInstance.post(
          "/physicalInventory/getCatalogCurrent",
          { storeId, supplierId, search, pageNo, pageSize },
          { signal: controller.signal }
        );
        setCatalog(result.data.data);
      } catch (error) {
      } finally {
        setIsLoading(false);
      }
    };

    loadCatalog();

    return () => controller.abort();
  }, [storeId, supplierId, search, pageNo, pageSize, toggle]);

  const refresh = () => setToggle((prev) => !prev);

  return { catalog, isLoading, refresh };
};
